module.exports = __webpack_public_path__ + "assets/img/team/anne-heimes.jpg";